import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Sidebar from "./components/Sidebar";
import { Container, Typography } from "@mui/material";
import About from "./components/About";
import CrossingsGrid from "./components/CrossingsGrid";
import FacilitiesGrid from "./components/FacilitiesGrid";
import FittingsGrid from "./components/FittingsGrid";
import LandUseGrid from "./components/LandUseGrid";
import SignIn from "./components/SignIn";
import LandingPage from "./components/LandingPage";
import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";
import { Toaster } from 'react-hot-toast';
import { InteractionStatus } from "@azure/msal-browser";
import ArcGISMap from "./components/ArcGISMap"
import { useLocation } from "react-router-dom";
import SummaryCard from "./components/Widgets/SummaryCard";
import '@esri/calcite-components/dist/calcite/calcite.css';
import '@esri/calcite-components/dist/components';

function App() {
  const location = useLocation();
  const isFullScreenMap = location.pathname === "/map-full";

  const [isSidebarOpen, setSidebarOpen] = React.useState(true);

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };
  const { instance, interactionStatus } = useMsal();
  const account = instance.getAllAccounts()[0];
  const loginHint = account?.username;

  const loginRequest = {
    scopes: ["user.read"],
    prompt: "select_account",
    loginHint,
  };

  // Handle redirect response once at startup
  useEffect(() => {
    instance.handleRedirectPromise()
      .then((response) => {
        if (response) {
          console.log("Redirect login response:", response.account);
        }
      })
      .catch((error) => {
        console.error("Redirect handling error:", error);
      });
  }, [instance]);

  // Then attempt silent login separately
  useEffect(() => {
    const trySilentLogin = async () => {
      try {
        const response = await instance.ssoSilent(loginRequest);
        console.log("Signed in silently:", response.account);
      } catch (error) {
        console.warn("Silent sign-in failed:", error);
        instance.loginRedirect(loginRequest);
      }
    };

    // Only try silent login if no interaction is in progress
    if (interactionStatus === InteractionStatus.None) {
      trySilentLogin();
    }
  }, [instance]);


  return (
    <div className="app-layout">
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          style: {
            fontSize: "14px",
            padding: "12px 16px",
            borderRadius: "6px",
          },
          error: {
            style: {
              background: "#ffffff",
              border: "1px solid red",
              color: "#d00000",
            },
            iconTheme: {
              primary: "red",
              secondary: "#ffffff",
            },
          },
          success: {
            style: {
              background: "#ffffff",
              border: "1px solid green",
              color: "#007f00",
            },
            iconTheme: {
              primary: "green",
              secondary: "#ffffff",
            },
          },
        }}
      />
      {account ? (
        isFullScreenMap ? (
          <></> // nothing when signed in + full screen map
        ) : (
          <>
          <SignIn /> 
          <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
          </>
        )
      ) : (
        <SignIn /> // show sign in if no account
      )}

      {isFullScreenMap && account ? (
        <Routes>
          <Route path="/map-full" element={<ArcGISMap />} />
        </Routes>
      ) : (
        <>
          {!account ? (
            // If no account, only show LandingPage
            <Routes>
              <Route path="/" element={<LandingPage />} />
            </Routes>
          ) : (
            // If account exists, show full app
            <>
              <div className="main-content">
                <Container className="with-top-border" maxWidth={false} sx={{ maxWidth: "100%" }}>
                  <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/crossings" element={<CrossingsGrid />} />
                    <Route path="/facilities" element={<FacilitiesGrid />} />
                    <Route path="/fittings" element={<FittingsGrid />} />
                    <Route path="/landuse" element={<LandUseGrid />} />
                    <Route path="/map" element={<ArcGISMap />} />
                    <Route path="/map-full" element={<ArcGISMap />} />
                  </Routes>
                </Container>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default App;
